import WebApp from '@twa-dev/sdk';

// PARA-131 (AC-16) — ЕДИНСТВЕННАЯ точка обращения к Telegram SDK в фиче
// биллинга: прямой `import WebApp from '@twa-dev/sdk'` где-либо ещё запрещён
// (тестируемость + один и тот же фолбэк во всех сценариях оплаты).
// Образец изоляции внешнего мира — features/auth/lib/acquisitionSource.ts.

/** Ровно четыре статуса колбэка платёжного шита (@twa-dev/types). */
export type InvoiceStatus = 'paid' | 'pending' | 'cancelled' | 'failed';

// openInvoice появился в Bot API 6.1 — сравнение строк версии вручную запрещено.
const MIN_INVOICE_API_VERSION = '6.1';

/** Платёжный шит доступен: метод есть и клиент не старше 6.1. */
export function isInvoiceSupported(): boolean {
  return (
    typeof WebApp.openInvoice === 'function' &&
    typeof WebApp.isVersionAtLeast === 'function' &&
    WebApp.isVersionAtLeast(MIN_INVOICE_API_VERSION)
  );
}

export function openInvoice(url: string, callback: (status: InvoiceStatus) => void): void {
  WebApp.openInvoice(url, (status) => callback(status as InvoiceStatus));
}

/** Фолбэк AC-16: invoice-ссылка открывается как обычная Telegram-ссылка.
 * Колбэка со статусом в этом сценарии не будет — вызывающий переводит экран
 * в состояние ожидания. Возвращает false, если недоступен и фолбэк: тогда
 * пользователю остаётся только обновить Telegram. */
export function openInvoiceFallback(url: string): boolean {
  if (typeof WebApp.openTelegramLink !== 'function') {
    return false;
  }
  WebApp.openTelegramLink(url);
  return true;
}
